import classNames from 'classnames';
import { Checkbox } from 'components/ui/Checkbox/Checkbox';
import type { ChangeEvent, PropsWithChildren } from 'react';
import './Accept.scss';

type AcceptProps = {
  checked?: boolean;
  className?: string;
  error?: boolean | string;
  name: string;
  readOnly?: boolean;
  required?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const Accept = ({
  checked = false,
  children,
  className,
  error,
  name,
  readOnly = false,
  required = false,
  onChange,
  onBlur,
}: PropsWithChildren<AcceptProps>) => {
  return (
    <div
      className={classNames('FormGroup FormGroup--block', {
        'has-error': error,
      })}
    >
      <div className={classNames('Accept', className)}>
        <Checkbox
          checked={checked}
          error={error}
          label={children}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          readOnly={readOnly}
          required={required}
          data-testid="checkbox"
        />
      </div>
    </div>
  );
};
